<template>
    <div class="link-analytics-perfection" @click="routeAnalyticsPerfection">
        <span class="link-analytics-perfection__heading">Kusursuzluk</span>
        <span class="link-analytics-perfection__text">Her bir sesbirimde ne kadar kusursuzlaştığını gör</span>
        <span class="link-analytics-perfection__art-pattern"></span>
        <span class="link-analytics-perfection__art-cute-diamond"></span>
    </div>
</template>
<script>
    export default {
        methods: {
            routeAnalyticsPerfection(){
                this.$router.push('/analytics/perfection');
            }
        }
    };
</script>
<style scoped src="@/css/components/link-analytics-perfection.css"></style>